import { createFileRoute } from "@tanstack/react-router";

import { ProfileSettings } from "@/features/settings";

/**
 * ``/settings`` (default) — Profilo. Mounted under the modal shell since
 * May 24, 2026 (the legacy non-modal `_authed/settings/` directory was
 * removed in the same change so deep links resolve to a single chrome).
 */
export const Route = createFileRoute("/_authed/_modal/settings/")({
  component: ProfileSettings,
});
